import React, { useEffect } from 'react';

function CategoryFilter(){
    useEffect(() => {
        const cats = localStorage.getItem("cat-form-44");
        if(cats){ 
            let newVal = cats.split(',')  
            let input = document.getElementById("categories-filter").querySelectorAll('input')[0];
            input.focus(); 
            document.execCommand('selectAll', false, null)
            document.execCommand('cut', false, null) 
            document.execCommand('insertText', false, newVal);
        } 
    });
    
    function saveChoices(){
        var checkboxes =  document.getElementsByClassName("switch-cat");
        var storage = []
        for (var i = 0; i < checkboxes.length; i++) { 
            if (checkboxes[i].type === "checkbox" && checkboxes[i].checked) { 
                storage.push( checkboxes[i].value); 
            }
        }
        
       localStorage.setItem("cat-form-44", storage.toString()); 
    }

    let catgories = {
        0: {
            label: "People",
            slug: "people",
        },
        1: {
            label: "Innovations",
            slug: "innovations",
        },
        2: {
            label: "Environment",
            slug: "environment",
        },
        3: {
            label: "Care",
            slug: "care",
        },
        4: {
            label: "Partners",
            slug: "partners",
        }, 
    }
    let catsArray = []
    const cats = localStorage.getItem("cat-form-44");
    if(cats){
        catsArray = cats.split(',')  
    }
 
    return (
        <div className="action-toggle-container">
            { Object.keys(catgories).map((index) => {
              return ( 
                <div className="action-toggle-cell" key={"switch-cat-"+index} >
                    <p className="action-toggle-label">{catgories[index].label}</p>
                        <div className="toggle-switch">
                        <input 
                            defaultChecked={catsArray.includes(catgories[index].slug)} 
                            type="checkbox" 
                            className="switch-cat"
                            id={"switch-cat-"+index} 
                            value={catgories[index].slug} 
                            onClick={
                                (event) => {
                                    let input = document.getElementById("categories-filter").querySelectorAll('input')[0];
                                    input.focus(); 

                                    if(event.target.checked){    
                                        if( input.value === ""){  
                                            document.execCommand('insertText', false, event.target.value); 
                                        }else{ 
                                            document.execCommand('insertText', false, ","+event.target.value); 
                                        }                
                                    }else{ 
                                        let currentVal = input.value
                                        let newCat = event.target.value;
                                        let newVal =  ""

                                        if( currentVal.includes(','+newCat) ){ 
                                            newVal =  currentVal.replace(","+newCat, '')
                                        }else if( currentVal.includes(newCat+',') ){ 
                                            newVal =  currentVal.replace(newCat+',', '')
                                        }else if( currentVal.includes(newCat) ){ 
                                            newVal = currentVal.replace(newCat, '')
                                        }else{
                                            newVal = "" 
                                        }

                                        document.execCommand('selectAll', false, null)
                                        document.execCommand('cut', false, null) 
                                        document.execCommand('insertText', false, newVal);
                                    }
                                    saveChoices()
                                }
                            }
                        />
                        <label htmlFor={"switch-cat-"+index}>    
                        {/* {props.onIcon}
                        {props.offIcon} */}
                        </label>
                    </div>
                </div>
              ); 
            })}  
        </div>
    );
}

export default CategoryFilter;
